










































































































































import { Component, Vue } from "vue-property-decorator";
import {
  AbsenceEditModel,
  AbsenceTypeEnum,
  AbsenceTypeViewModel,
  AbsenceValidationResultViewModel,
  StSelectListItem
} from "@/services/api/nswag/stapiclient_generated";
import { stAbsenceApi, stAbsenceTypeApi, stAppUserApi } from "@/services/st-api";
import AppUserHistory from "@/views/User/History/AppUserHistory.vue";
import AppUserVacationHistory from "@/views/User/VacationHistory/AppUserVacationHistory.vue";
import SlideIn from "@/components/basic/SlideIn.vue";
import StInput2 from "@/components/basic/StInput2.vue";
import StSelect from "@/components/basic/StSelect.vue";
import StToggle from "@/components/basic/StToggle.vue";
import { notifySuccess } from "@/utlitities/notifications";
import StExplanation from "@/components/basic/StExplanation.vue";
import AppUserProjectStaffEdit from "@/views/User/AppUserProjectStaffEdit.vue";
import StTabs from "@/components/tabs/StTabs.vue";
import StDatePicker from "@/components/basic/StDatePicker.vue";
import { DateTime } from "luxon";
import { DialogResponse } from "vue-tailwind/dist/components/TDialog";
import { UserStore } from "@/store/user-module";

@Component({
  components: {
    StDatePicker,
    StTabs,
    StExplanation,
    AppUserHistory,
    AppUserVacationHistory,
    SlideIn,
    StInput2,
    StSelect,
    StToggle,
    AppUserProjectStaffEdit
  }
})
export default class AbsenceEdit extends Vue {
  loading = false;
  delayLoading = false;
  absenceEditModel: AbsenceEditModel = AbsenceEditModel.fromJS({});
  absenceTypes: AbsenceTypeViewModel[] = [];
  absenceId: number = 0;
  day: string | null = "";
  appUserId: number = 0;
  users: StSelectListItem[] = [];
  absenceValidationViewModel: AbsenceValidationResultViewModel = AbsenceValidationResultViewModel.fromJS({});
  readonlyAbsenceTypeViewModel: AbsenceTypeViewModel = AbsenceTypeViewModel.fromJS({});

  isOwnAbsencesEdit: boolean = true;
  invalid: boolean = false;

  private saving: boolean = false;

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.$route.meta.backRouteName });
  }

  async created() {
    this.loading = true;

    this.isOwnAbsencesEdit = this.$router.currentRoute.name == "OwnabsencesEdit" || !this.canEditAbsencesForEmployees;
    this.absenceId = parseInt(this.$route.params.id);
    if (this.$route.query.day && this.$route.query.day.length) {
      this.day = this.$route.query.day as string;
    }
    if (this.$route.query.userId && this.$route.query.userId.length) {
      this.appUserId = parseInt(this.$route.query.userId as string);
    }
  }

  async mounted() {
    this.loading = true;
    this.openSlideIn();
    if (this.absenceId == 0) {
      if (this.day) {
        this.absenceEditModel = await stAbsenceApi.getNewForDay(this.day);
      } else {
        this.absenceEditModel = await stAbsenceApi.getNew();
      }

      if (this.appUserId) {
        this.absenceEditModel.appUserId = this.appUserId;
      }
    } else {
      this.absenceEditModel = await stAbsenceApi.get(this.absenceId);
    }

    if (this.absenceEditModel.isReadOnly) {
      this.readonlyAbsenceTypeViewModel = (await stAbsenceTypeApi.getViewModelById(this.absenceEditModel.absenceTypeId));
    } else {
      await this.loadAbsenceTypes();
      this.users = await stAppUserApi.getSelectListForListTimeEntry(this.absenceEditModel.appUserId ?? 0);
    }

    this.loading = false;
    await this.$nextTick();
  }

  async reloadAbsenceTypes(){
    try{
      this.delayLoading=true;
      await this.loadAbsenceTypes();
    }finally{
      this.delayLoading=false;
    }
  }

  async loadAbsenceTypes(){
    this.absenceTypes = await stAbsenceApi.getListAbsenceTypeForUser(this.absenceEditModel.appUserId);
  }

  get absenceTypeViewModel() {
    if (this.absenceEditModel.isReadOnly) {
      return this.readonlyAbsenceTypeViewModel;
    } else {
      return this.absenceTypes.find(x => x.id == this.absenceEditModel.absenceTypeId);
    }
  }

  get halfDayMakesSense(){
    return DateTime.fromISO(this.absenceEditModel.dateFrom).toISODate() == DateTime.fromISO(this.absenceEditModel.dateTo).toISODate();
  }

  get canEditAbsencesForEmployees() {
    return this.userSettings.CanEditAbsencesForEmployees;
  }

  get userSettings() {
    return UserStore.userSettings;
  }

  get isReadOnly(): boolean {
    if (!this.absenceEditModel) return true;

    return this.absenceEditModel.isReadOnly!;
  }

  get absenceType(): AbsenceTypeViewModel | undefined {
    let absenceType = this.absenceTypes.find((_) => _.id == this.absenceEditModel.absenceTypeId);
    return absenceType;
  }

  get isVacation(): boolean {
    if (!this.absenceType) {
      return false;
    }
    return this.absenceType.isVacation!;
  }

  get halfDayAllowed(): boolean {
    if (this.absenceType && this.absenceType.allowHalfDay) {
      return true;
    }

    return false;
  }

  get isHalfDay(): boolean {
    return this.halfDayAllowed && this.absenceEditModel.isHalfDay!;
  }

  get canDelete(): boolean {
    return !!this.absenceEditModel.id && !this.isReadOnly;
  }

  changeHalfDay(val: boolean) {
    if (val) {
      this.absenceEditModel.dateTo = this.absenceEditModel.dateFrom;
    }

    this.validateAbsence();
  }

  changeDateTo(val: string) {
    let dateFrom = DateTime.fromISO(this.absenceEditModel.dateFrom!);
    let dateTo = DateTime.fromISO(this.absenceEditModel.dateTo!);

    if (dateTo < dateFrom) {
      this.absenceEditModel.dateFrom = this.absenceEditModel.dateTo;
    }

    if(!this.halfDayMakesSense){
      this.absenceEditModel.isHalfDay = false;
    }

    this.validateAbsence();
  }

  changeDateFrom(val: string) {
    let dateFrom = DateTime.fromISO(this.absenceEditModel.dateFrom!);
    let dateTo = DateTime.fromISO(this.absenceEditModel.dateTo!);

    if (dateFrom > dateTo) {
      this.absenceEditModel.dateTo = this.absenceEditModel.dateFrom;
    }

    if(!this.halfDayMakesSense){
      this.absenceEditModel.isHalfDay = false;
    }

    this.validateAbsence();
  }

  async validateAbsence() {
    try {
      this.delayLoading = true;
      this.absenceValidationViewModel = await stAbsenceApi.validateAbsence(this.absenceEditModel);
    } finally {
      this.delayLoading = false;
    }
  }

  async deleteAbsence() {
    const res: DialogResponse = await this.$dialog.confirm({
      title: this.$t("Bestätigung").toString(),
      text: this.$t("Möchten Sie diese Abwesenheit wirklich löschen?"),
      variant: "danger",
      okButtonText: this.$t("Löschen").toString(),
      cancelButtonText: this.$t("Abbrechen").toString()
    });
    if (res.isOk) {
      await stAbsenceApi.delete(this.absenceEditModel.id!, true);
      notifySuccess("Erfolgreich gelöscht");
      this.closeSlideIn();
    }
  }

  async submit() {
    try {
      this.saving = true;
      let successText = "Erfolgreich gespeichert";

      if (this.absenceEditModel.id == 0) {
        await stAbsenceApi.post(this.absenceEditModel);
        successText = "Abwesenheit angelegt";
      } else {
        await stAbsenceApi.put(this.absenceEditModel.id, this.absenceEditModel);
      }

      notifySuccess(successText);

      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
